import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=6cd6134c&scoped=true"
import script from "./AppDownload.vue?vue&type=script&lang=ts"
export * from "./AppDownload.vue?vue&type=script&lang=ts"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=6cd6134c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6134c",
  null
  
)

export default component.exports